// extracted by mini-css-extract-plugin
export default {"parent":"bajaj_parent__LM493","bap":"bajaj_bap__j8sGt"};